@use "@fukuri-admins/ui/layout" as *;

.content {
  @include typography('Jp/12_W3');
  position: fixed;
  transform: translate(-50%, calc(-100% - 8px));
  opacity: 0;
  visibility: hidden;
  width: max-content;
  max-width: 320px;
  white-space: normal;
  text-align: left;
  color: text('White');
  background: background('Gray_Darken');
  padding: spacing('8') spacing('12');
  border-radius: borderRadius('sm');
  // Modal(1500) / Toast(2000) / Dropdown(99999) 等すべてのオーバーレイより前面に表示する
  z-index: 100000;
  pointer-events: none;
  transition: opacity 120ms ease, visibility 120ms ease;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: calc(50% + var(--tooltip-arrow-offset, 0px));
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 6px 6px 0 6px;
    border-color: background('Gray_Darken') transparent transparent transparent;
  }
}

.below {
  transform: translate(-50%, 8px);

  &::after {
    top: auto;
    bottom: 100%;
    left: calc(50% + var(--tooltip-arrow-offset, 0px));
    border-width: 0 6px 6px 6px;
    border-color: transparent transparent background('Gray_Darken') transparent;
  }
}

.open {
  opacity: 1;
  visibility: visible;
}
